import React from 'react';
import styled from 'styled-components/macro';
import { Container } from '@yme/atoms/grid';
import { Image, ImageStyled } from '@yme/atoms/image';
import { SVGIcon } from '@yme/atoms/svg-icon';
import { colorBlackTransparent300, HERO_SECTION_BACKGROUND_SECOND, colorCoreBlack900Base, colorCoreBlack300, colorCoreBackground1000, colorCoreWhite1000, } from '@yme/tokens/colors';
import { FlexWrapper } from '@yme/tokens/flexTokens';
import { ADAPTIVE } from '@yme/tokens/screen';
import { HeadingLevel1, RegularTextLevel3 } from '@yme/tokens/typography';
import { getTextStyles } from '@yme/utils/styles';
export const HeroComponentStyled = styled.div `
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  min-height: 154px;
  width: 100%;
  height: 100%;
  overflow-wrap: break-word;

  ${ADAPTIVE.minWidth.tablet} {
    min-height: 330px;
  }

  ${ADAPTIVE.minWidth.desktop} {
    min-height: 617px;
    max-width: 1920px;
    margin: 0 auto;
  }
`;
export const ImageBgStyled = styled.div `
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;

  background-color: ${colorBlackTransparent300};

  ${ADAPTIVE.minWidth.tablet} {
    background: ${HERO_SECTION_BACKGROUND_SECOND};
  }

  ${ImageStyled} {
    height: 100%;
    object-fit: cover;
    object-position: center center;
  }
`;
export const ImageMaskStyled = styled.div `
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;

  background-color: ${colorBlackTransparent300};

  ${ADAPTIVE.minWidth.tablet} {
    background: ${HERO_SECTION_BACKGROUND_SECOND};
  }
`;
export const BottomContainer = styled(Container) `
  width: 100%;
  bottom: 0;
  left: 0;
  padding-bottom: 16px;

  ${ADAPTIVE.minWidth.tablet} {
    padding-bottom: 24px;
  }

  ${ADAPTIVE.minWidth.desktop} {
    padding-bottom: 48px;
  }
`;
export const CountryFlagStyled = styled(Image) `
  margin-top: 10px;
  max-width: 58px;

  ${ADAPTIVE.minWidth.tablet} {
    margin-top: 16px;
    max-width: 92px;
  }

  ${ADAPTIVE.minWidth.desktop} {
    margin-top: 24px;
    max-width: 131px;
  }
`;
export const LogoStyled = styled(Image) `
  max-width: 70px;

  ${ADAPTIVE.minWidth.tablet} {
    max-width: 112px;
  }

  ${ADAPTIVE.minWidth.desktop} {
    max-width: 160px;
  }
`;
export const HeaderTitle = styled(HeadingLevel1) `
  ${ADAPTIVE.maxWidth.mobile} {
    ${getTextStyles('Play', 700, 28, 32)};

    margin-bottom: 16px;
  }

  ${ADAPTIVE.maxWidth.tablet} {
    ${getTextStyles('Play', 700, 32, 40)};
  }
`;
export const LeadingSvg = styled(
// eslint-disable-next-line @typescript-eslint/no-unused-vars
({ isRightToLeft, ...props }) => React.createElement(SVGIcon, { ...props })) `
  margin: ${({ isRightToLeft }) => (isRightToLeft ? '2px 0 0 16px' : '2px 16px 0 0')};
`;
export const TextWithIcon = styled.div `
  display: flex;
  align-items: flex-start;
  flex-wrap: nowrap;
  margin-bottom: 20px;

  ${getTextStyles('Ubuntu', 400, 16, 24)}
  color: ${colorCoreBlack300};

  &:last-child {
    margin-bottom: 0;
  }
`;
export const Desription = styled(RegularTextLevel3) `
  font-weight: 400;
  white-space: break-spaces;
  margin-top: 24px;
  color: ${colorCoreBlack900Base};

  ${ADAPTIVE.minWidth.tablet} {
    margin-top: 32px;
  }

  ${ADAPTIVE.minWidth.desktop} {
    margin-top: 48px;
  }
`;
export const MainContent = styled.div `
  padding: 24px 0;
  background-color: ${colorCoreWhite1000};

  ${ADAPTIVE.minWidth.tablet} {
    padding: 32px 0;
  }

  ${ADAPTIVE.minWidth.desktop} {
    padding: 48px 0;
  }
`;
export const ViewMapLabel = styled.span `
  margin: ${({ isRightToLeft }) => (isRightToLeft ? '0 0 0 8px' : '0 8px 0 0')};
`;
export const ViewMap = styled.a `
  display: flex;
  align-items: center;
  cursor: pointer;
  text-decoration: none;

  ${getTextStyles('Ubuntu', 500, 14, 20)}
  color: ${colorCoreBlack900Base};
`;
export const LocationTitle = styled.span `
  margin: ${({ isRightToLeft }) => (isRightToLeft ? '0 0 0 12px' : '0 12px 0 0')};
`;
export const RegisterBlock = styled.div `
  ${({ hasPrice }) => (hasPrice && `background-color: ${colorCoreBackground1000};`) || ''}

  box-sizing: border-box;
  padding: 24px;

  ${ADAPTIVE.maxWidth.mobile} {
    width: 100%;
  }
`;
export const InfoBlock = styled(FlexWrapper) `
  width: 100%;
`;
export const InfoBlockRowStyled = styled.div `
  flex: 1;
`;
export const DateFromStyled = styled.div `
  direction: ltr;
`;
